import _ from 'lodash';
import GraphqlBuilder from "utils/request/graphql/builder";
import QueryTimeslotCapacity from "graphql/queries/QueryTimeslotCapacity";
import store from "services/redux/store";
import { addTimeslotsOccupied, addTimeslotsOccupiedMyFavourites } from "services/redux/data/actions";
import { bookingConstants } from "utils/constants/booking-constants";
import { constantsGraphql } from 'utils/constants/constants'

const FetchTimeslotCapacity = {
	
	key: ( date, timeslot ) => {
		const list = [];
		
		const objects = {
			ts: timeslot,
		}
		
		_.forEach( objects, (item, k) => {
			const guid = _.get( item, 'guid', null );
			
			list.push( `${k}:${guid !== null ? guid : '?'}` );
		});
		
		return list.join('--') +'--'+ date
	},
	
	keyByBooking: ( booking ) => {
		return FetchTimeslotCapacity.key(
			booking?.booking_date,
			_.get( booking, ['timeslot'], {} ),
		);
	},

	fetch: ( { building = {}, floor = {}, room = {}, bookings = [], timeslots = [] , dates, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		// Create the builder
		let graphqlBuilder = new GraphqlBuilder();

		let hasArray = false;
		
		if( Array.isArray( building ) ) {
			hasArray = true;
			
			// loop through the buildings
			building.forEach( item => {
				const tt = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = FetchTimeslotCapacity.addQueryByDates( graphqlBuilder, item, {}, {}, tt, dates );
			});
		}

		if( Array.isArray( floor ) && hasArray === false ) {
			hasArray = true;
			
			// loop through the buildings
			floor.forEach( item => {
				const tt = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = FetchTimeslotCapacity.addQueryByDates( graphqlBuilder, {}, item, {}, tt, dates );
			});
		} else if( hasArray ) {
			return;
		}

		if( Array.isArray( room ) && hasArray === false ) {
			hasArray = true;
			// loop through the buildings
			room.forEach( item => {
				const tt = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = FetchTimeslotCapacity.addQueryByDates( graphqlBuilder, {}, {}, item, tt, dates );
			});
		} else if( hasArray ) {
			return;
		}

		if( hasArray === false ) {
			graphqlBuilder = FetchTimeslotCapacity.addQueryByDates( graphqlBuilder, building, floor, room, timeslots, dates );
		}

		if( _.size( bookings ) > 0 ) {
			graphqlBuilder = FetchTimeslotCapacity.addQueryByBookings( graphqlBuilder, bookings );
		}
		
		graphqlBuilder.setOnStart( () => {
			return FetchTimeslotCapacity.onStart(callbackStart);
		} );
		
		graphqlBuilder.setOnSuccess( result => {
			return FetchTimeslotCapacity.onSuccess(result, callbackSuccess);
		} )
		
		graphqlBuilder.setOnError( result => {
			return FetchTimeslotCapacity.onError(result, callbackError);
		} );
		
		if( _.size( graphqlBuilder.queries ) > 0 ) {
			graphqlBuilder.execute();
			return graphqlBuilder;
		}
		
		FetchTimeslotCapacity.onSuccess( null, callbackSuccess )
		return null
	},
	
	/**
	 *
	 * @param bookings
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	fetchByBookings: ( bookings = [], { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		let graphqlBuilder = new GraphqlBuilder();
		graphqlBuilder = FetchTimeslotCapacity.addQueryByBookings( graphqlBuilder, bookings );
		
		graphqlBuilder.setOnStart( () => {
			return FetchTimeslotCapacity.onStart(callbackStart);
		} );
		
		graphqlBuilder.setOnSuccess( result => {
			return FetchTimeslotCapacity.onSuccess(result, callbackSuccess);
		} )
		
		graphqlBuilder.setOnError( result => {
			return FetchTimeslotCapacity.onError(result, callbackError);
		} );
		
		if( _.size( graphqlBuilder.queries ) > 0 ) {
			graphqlBuilder.execute();
			return;
		}
		
		FetchTimeslotCapacity.onSuccess( null, callbackSuccess )
	},
	
	onError: ( result, callbackError = null ) => {
		if( callbackError !== null && _.isFunction( callbackError ) ) {
			callbackError( result );
		}
	},
	
	onStart: ( callbackStart = null ) => {
		if( callbackStart !== null && _.isFunction( callbackStart ) ) {
			callbackStart();
		}
	},
	
	/**
	 * Function for creating the occupied timeslots by employee guid
	 * @param result
	 * @param callbackSuccess
	 */
	onSuccess: ( result, callbackSuccess = null ) => {
		const timeslotsOccupied = {};
		const timeslotsOccupiedMyFavourites = {};
		
		if( result !== null ) {
			_.forEach( result, ( item, key ) => {
				
				const timeslotCapacity = _.get( item, 'timeslot_capacity', {} );
				
				// Get the count
				timeslotsOccupied[ key ] = timeslotCapacity
				
				// Add the favourites
				timeslotsOccupiedMyFavourites[ key ] = _.map( timeslotCapacity.employee_favourites ?? [], o => {
					return {
						employee_guid: o
					}
				})
			});
			
			// Store in redux
			if( _.size( timeslotsOccupied ) > 0 ) {
				store.dispatch( addTimeslotsOccupied( timeslotsOccupied ) );
			}
			
			// Push to the store ALWAYS
			store.dispatch( addTimeslotsOccupiedMyFavourites( timeslotsOccupiedMyFavourites ) );
		}
		
		if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
			callbackSuccess( timeslotsOccupied );
		}
	},
	
	/**
	 *
	 * @param graphqlBuilder
	 * @param bookings
	 * @returns {*}
	 */
	addQueryByBookings: ( graphqlBuilder, bookings = [] ) => {
		_.forEach( bookings, booking => {
			const building = _.get( booking, 'building', {} );
			const floor = _.get( booking, 'floor', {} );
			const room = _.get( booking, 'room', {} );
			const slot = _.get( booking, 'timeslot', {} );
			const buildingParkingSpace = _.get( booking, 'building_parking_space', {} );
			
			if( !_.isEmpty( slot.guid ) ) {
				const key = FetchTimeslotCapacity.keyByBooking( booking );
				
				const variables = {
					building_guid: _.get( building, 'guid', null ),
					floor_guid: _.get( floor, 'guid', null ),
					room_guid: _.get( room, 'guid', null ),
					timeslot_guid: _.get( slot, 'guid', null ),
					building_parking_space_guid: _.get( buildingParkingSpace, 'guid', null ),
					kind: _.get( slot, 'kind', null ),
					booking_date: booking.booking_date,
					active: constantsGraphql.YES_NO
				};
				
				graphqlBuilder.addQuery( key, QueryTimeslotCapacity, variables )
			}
		});
		
		return graphqlBuilder;
	},
	
	/**
	 *
	 * @param graphqlBuilder
	 * @param building
	 * @param floor
	 * @param room
	 * @param timeslots
	 * @param dates
	 * @returns {*}
	 */
	addQueryByDates: ( graphqlBuilder, building = {}, floor = {}, room = {}, timeslots, dates ) => {
		// Check if it is an array, so not make it one
		if( !_.isArray( dates ) ) {
			dates = [ dates ];
		}
		
		const buildingGuid = _.get( building, 'guid', null );
		const floorGuid = _.get( floor, 'guid', null );
		const roomGuid = _.get( room, 'guid', null );
		
		_.forEach( dates, date => {
			_.forEach( timeslots, timeslot => {
				const kind = _.get( timeslot, 'kind', null );
				const timeslotGuid = _.get( timeslot, 'guid', null );
				const timeslotBy = _.get( timeslot, 'timeslot_by', null );
				
				let queryVars = {
					building_guid: null,
					floor_guid: null,
					room_guid: null,
					timeslot_guid: timeslotGuid,
					kind: kind,
					booking_date: date,
					active: constantsGraphql.YES
				}
				
				switch( timeslotBy ) {
					case 'building':
						queryVars.building_guid = buildingGuid
						queryVars.floor_guid = null
						queryVars.room_guid = null
						break;
						
					case 'floor':
						queryVars.building_guid = buildingGuid
						queryVars.floor_guid = floorGuid
						queryVars.room_guid = null
						break;
						
					default:
					case 'room':
						queryVars.building_guid = buildingGuid
						queryVars.floor_guid = floorGuid
						queryVars.room_guid = roomGuid
						break;
				}
				
				graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot ), QueryTimeslotCapacity, queryVars );
				
				switch( kind ) {
					case bookingConstants.LUNCH:
						break;
					
					case bookingConstants.TRANSPORT:
						const buildingParkingSpace = _.get( timeslot, 'building_parking_space', {} );
						const transportKind = _.get( timeslot, 'transport_kind', null );
						
						if( !_.isEmpty( buildingParkingSpace ) ) {
							graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot ), QueryTimeslotCapacity, {
								building_guid: buildingGuid,
								floor_guid: null,
								room_guid: null,
								timeslot_guid: timeslotGuid,
								transport_kind: transportKind,
								building_parking_space_guid: _.get( buildingParkingSpace, 'guid', null ),
								kind: kind,
								booking_date: date,
								active: constantsGraphql.YES
							} );
						}
						break;
				}
			});
		});
		
		return graphqlBuilder;
	},

	extractKeys: ( identifier ) => {
		const identifiers = identifier.split( "--" );
		
		const result = {
			building: null,
			floor: null,
			room: null,
			timeslot: null,
			transport_kind: null,
			building_parking_space: null
		};

		identifiers.forEach( ( identifierPart ) => {
			const [ identifierType, identifierValue ] = identifierPart.split( ":" );

			if( identifierValue === '?' ) {
				return;
			}

			switch( identifierType ) {
				case 'b':
					result.building = identifierValue;
					break;
					
				case 'f':
					result.floor = identifierValue;
					break;
					
				case 'r':
					result.room = identifierValue;
					break;
					
				case 'ts':
					result.timeslot = identifierValue;
					break;
					
				case 'tk':
					result.transport_kind = identifierValue;
					break;
					
				case 'bps':
					result.building_parking_space = identifierValue;
					break;
			}
		});

		return result;
	}
}

export default FetchTimeslotCapacity
